<template>
  <header v-responsive="_updateHeight" class="app-header" :class="classes">
    <div ref="content" class="app-header__wrap">
      <div class="app-header__content">
        <slot />
      </div>
    </div>
  </header>
</template>

<script>
import Applicationable from "@mixins/applicationable";
import mixins from "@utils/mixins";

export default mixins(Applicationable("top", ["computedHeight"])).extend({
  name: "AppHeaderDrawer",
  props: {
    fixed: Boolean
  },

  data() {
    return {
      internalContentHeight: 0
    };
  },

  computed: {
    computedHeight() {
      return this.internalContentHeight;
    },

    computedLeft() {
      return this.$core.application.left;
    },
    computedRight() {
      return this.$core.application.right;
    },

    classes() {
      return {
        "app-header_fixed": this.fixed
      };
    }
  },

  methods: {
    updateApplication() {
      return this.computedHeight;
    },

    _updateHeight() {
      this.internalContentHeight =
        (this.$refs.content && this.$refs.content.offsetHeight) || 0;
    }
  }
});
</script>

<style lang="scss">
.app-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: auto;
  z-index: 8;

  &_fixed {
    position: fixed;
    @include elevation(5);

    .mobile-menu__content.menuable__content__active + .application_wrap & {
      @include elevation(0);
    }
  }
}
</style>
